export const ALGONOMY_TOP_CATEGORY_EN = '9082'; // 9082 = 'Products' category id on prod, 10602 is 'Produits'
export const ALGONOMY_TOP_CATEGORY_FR = '10602';
